// extracted by mini-css-extract-plugin
export default {"statusTag":"src-pages-SalesCannelVersion-SalesChannelDiscounts-Components-StatusTag-css-module__statusTag--Ipo9+"};